import gql from "graphql-tag";
import { partnerTypeDef } from "../definitions/partner-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const partnerListQuery = gql`
  query PartnerList{
    partner {
      list {
        output{
          ${partnerTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default partnerListQuery;
